import { findForMultipleCompanies, searchUsers } from "@/api/autocomplete/api";
import type { SelectOption } from "@/components/common/Dropdown/types";
import type { StylesConfig } from "react-select";

export const ENGAGEMENT_SELECT_STYLES: StylesConfig<SelectOption, true> = {
  control: (base, state) => ({
    ...base, minHeight: "34px", fontSize: "0.8125rem",
    backgroundColor: "#F9FAFB", borderColor: state.isFocused ? "#3b82f6" : "#D1D5DB",
    boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none",
    "&:hover": { borderColor: "#9CA3AF" },
  }),
  valueContainer: base => ({ ...base, padding: "0 8px" }),
  input: base => ({ ...base, fontSize: "0.8125rem" }),
  menu: base => ({ ...base, zIndex: 20, fontSize: "0.8125rem" }),
  placeholder: base => ({ ...base, color: "#9CA3AF" }),
  singleValue: base => ({ ...base, color: "#1F2937" }),
};

export async function loadCompanyOptions(inputValue: string): Promise<SelectOption[]> {
  try {
    const results = await findForMultipleCompanies(inputValue);
    return results.map(r => ({ value: r.id, label: r.label }));
  } catch { return []; }
}

export async function loadUserOptions(inputValue: string): Promise<SelectOption[]> {
  if (inputValue.length < 2) return [];
  try {
    const results = await searchUsers(inputValue);
    return results.map(r => ({ value: r.id, label: r.label }));
  } catch { return []; }
}
